var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('span',{staticClass:"action-icon nt-edit",on:{"click":_vm.editHandler}})])}
var staticRenderFns = []

export { render, staticRenderFns }